module.exports = __webpack_public_path__ + "static/media/gf.cb06b699.svg";